import { isNullish, MaybeArray } from "helpers"

export const isArray = <T>(x: MaybeArray<T>): x is T[] => !isNullish(x) && Array.isArray(x)

export const asArray = <T>(a: MaybeArray<T>): T[] => {
  if (isNullish(a)) return []
  if (isArray(a)) return a;
  return [a]
}
export const asNonNullishArray = <T>(a: MaybeArray<T>): NonNullable<T>[] => {
  return asArray(a).filter(v => !isNullish(v)) as NonNullable<T>[]
}


export const maybeArrayToString = <T>(vs: MaybeArray<T>, formatStr?: boolean): string => {
  const arr = (Array.isArray(vs) ? vs : [vs]).reduce((results, v) => {
      if (isNullish(v)) return results;
      return results.concat((formatStr ? `"${v}"` : `${v}`));
    }, [] as string[]
  )

  return `[${arr.join(',')}]`
}


export const removeItemOnce = <T extends any>(arr: T[], value: T): T[] => {
  const index = arr.indexOf(value)
  if (index > -1) {
    arr.splice(index, 1)
  }
  return arr
}

export const removeItemAll = <T extends any>(arr: T[], value: T): T[] => {
  let i = 0
  while (i < arr.length) {
    if (arr[i] === value) {
      arr.splice(i, 1)
    } else {
      ++i
    }
  }
  return arr
}

export const distinctArray = <A extends string | number>(arr: A[]): A[] => [
  ...new Set(arr),
]

export const addToDistinctArray = <T extends string | number>(
  arr: T[],
  value: T
) => distinctArray([...arr, value])
export const removeFromDistinctArray = <T extends string | number>(
  arr: T[],
  value: T
) => removeItemOnce(distinctArray(arr), value)

export const createEntitiesMap = <T extends any, K extends string = string>(
  entityObject: Record<K, T>
): {
  ids: K[]
  entities: T[]
} => {
  const keys: K[] = Object.keys(entityObject) as K[]
  const values: T[] = keys.map((key) => entityObject[key]) as T[]

  return {
    ids: keys,
    entities: values,
  }
}
